import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { PhoneCall, Activity, FileText, Users, Globe } from "lucide-react";
import { useServerStatus } from "@/hooks/use-server-status";
import { toast } from "sonner";

const tabs = [
  { label: "Configuration", path: "/config", icon: <PhoneCall size={16} /> },
  { label: "Monitoring", path: "/calls/active", icon: <Activity size={16} /> },
  { label: "Call Logs", path: "/calls/history", icon: <FileText size={16} /> },
  { label: "Administration", path: "/admin", icon: <Users size={16} /> },
];

export function TabBar() {
  const { data: status } = useServerStatus();

  const copyText = (text: string, label: string) => {
    navigator.clipboard.writeText(text).then(() => toast.success(`Copied: ${label}`));
  };

  return (
    <div className="flex items-center h-12 px-4 gap-1 bg-tab-bar border-b border-border">
      <div className="text-sm font-bold text-primary mr-6 tracking-tight">
        voicing
      </div>
      {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors",
                isActive
                  ? "bg-muted text-foreground font-medium"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              )
            }
          >
            {tab.icon}
            {tab.label}
          </NavLink>
        ))}
      <div className="flex-1" />
      {status?.public_ip && (
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Globe size={13} />
          <span
            className="font-mono cursor-pointer hover:text-foreground hover:underline transition-colors"
            title="Click to copy"
            onClick={() => copyText(status.public_ip!, status.public_ip!)}
          >
            {status.public_ip}
          </span>
          {status.public_url && (
            <button
              className="font-mono text-primary/80 cursor-pointer hover:text-primary hover:underline transition-colors ml-0.5"
              title="Click to copy"
              onClick={() => copyText(status.public_url!.replace(/^sip:/, ""), status.public_url!)}
            >
              {status.public_url}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
